interface FirehoseAnalyticsObject {
  title: string;
  value: string;
}

interface AnalyticsObjectModel {
  [key: string]: string | FirehoseAnalyticsObject;
}
interface AnalyticsConfigurationModel {
  FIREHOSE_ACTIONS: AnalyticsObjectModel;
  FIREHOSE_CATEGORIES: AnalyticsObjectModel;
  FIREHOSE_OBJECTS: AnalyticsObjectModel;
}

export default class FirehoseAnalyticsConfigurations {
  constructor() {}

  public setAnalyticsConfigs(): void {
    this._setupAnalyticsConfigs();
  }

  private _setupAnalyticsConfigs(): void {
    console.log('+++ static FirehoseAnalyticsConfigurations.setupConfigurations');
    // THESE ARE ALL THE ACTIONS, CATEGORIES, AND OBJECTS THAT TRIGGER AN ANALYTICS EVENT
    // IF YOU WANT TO TRACK AN NEW EVEN PLACE THE ACTION(S) HERE.
    // NOTE: THIS IS ONLY FOR NEW FIREHOSE ANALYTICS. THESE CONFIGS DON'T MAP TO OUR DB OR ANYTHING

    // *********** IMPORTANT ********* IF YOU WANT TO CHANGE DROPDOWN MENU ITEMS ONLY CHANGE THE TITLE AND NOT THE VALUE. THE VALUE IS WHAT IS SEARCHED FOR AND RECORDED IN AWS TIMESTREAM

    const ANALYTICS_CONFIGURATION: AnalyticsConfigurationModel = {
      FIREHOSE_ACTIONS: {
        ACTION_ANALYTICS: {
          title: 'Analytics',
          value: 'Analytics',
        },
        ACTION_VIEW: {
          title: 'Viewed',
          value: 'View',
        },
        ACTION_SAVE: {
          title: 'Saved',
          value: 'Save',
        },
        ACTION_JOIN: {
          title: 'Joined',
          value: 'Join',
        },
        ACTION_LEAVE: {
          title: 'Leave',
          value: 'Leave',
        },
        ACTION_CHAT: {
          title: 'Chat Message',
          value: 'Chat',
        },
        ACTION_DECLINE_CHAT: {
          title: 'Declined Chat',
          value: 'Chat Decline',
        },
        ACTION_KICKED: {
          title: 'Kicked',
          value: 'Kicked',
        },
        ACTION_BANNED: {
          title: 'Banned',
          value: 'Banned',
        },
        ACTION_MOD: {
          title: 'Chat Message Moderation',
          value: 'Mod',
        },
        ACTION_QA: {
          title: 'Asked Q&A Question',
          value: 'QA',
        },
        ACTION_QUESTION: {
          title: 'Question',
          value: 'Question',
        },
        ACTION_ANSWER: {
          title: 'Answer',
          value: 'Answer',
        },
        ACTION_CLICK: {
          title: 'Clicked',
          value: 'Click',
        },
        ACTION_COMMENT: {
          title: 'Commented',
          value: 'Comment',
        },
        ACTION_DOWNLOAD: {
          title: 'Downloaded',
          value: 'Download',
        },
        ACTION_FOLLOW: {
          title: 'Followed (forum topic)',
          value: 'Follow',
        },
        ACTION_UNFOLLOW: {
          title: 'Unfollowed (forum topic)',
          value: 'Unfollow',
        },
        ACTION_START: {
          title: 'Start',
          value: 'Start',
        },
        ACTION_COMPLETE: {
          title: 'Complete',
          value: 'Complete',
        },
        ACTION_EMOJI: {
          title: 'Emoji',
          value: 'Emoji',
        },
        ACTION_LIKE: {
          title: 'Like',
          value: 'Like',
        },
        ACTION_UNLIKE: {
          title: 'Unlike',
          value: 'Unlike',
        },
        ACTION_REVIEW: {
          title: 'User Submitted a Review',
          value: 'Review',
        },
        ACTION_PLAY: {
          title: 'Played a Video',
          value: 'Play',
        },
        ACTION_WATCH: {
          title: 'Watched',
          value: 'Watch',
        },
        ACTION_RAISEHAND: {
          title: 'Raise Hand',
          value: 'Raise Hand',
        },
        ACTION_SCHEDULE: {
          title: 'Scheduled',
          value: 'Schedule',
        },
        ACTION_UNSCHEDULE: {
          title: 'Unschedule',
          value: 'Unschedule',
        },
        ACTION_CLAIM: {
          title: 'Credits Claimed',
          value: 'Claimed',
        },
        ACTION_EARN: {
          title: 'Earn',
          value: 'Earn',
        },
        ACTION_EARN_CREDIT: {
          title: 'Earned Credit',
          value: 'Earn Credit',
        },
        ACTION_EARN_GRADE: {
          title: 'Earned Grade',
          value: 'Earn Grade',
        },
        ACTION_FAIL: {
          title: 'Failed',
          value: 'Fail',
        },
        ACTION_MESSAGE: {
          title: 'Message',
          value: 'Message',
        },
        ACTION_SEND_INVITE: {
          title: 'Send Invite',
          value: 'Send Invite',
        },
        ACTION_RECEIVE_INVITE: {
          title: 'Receive Invite',
          value: 'Recieve Invite',
        },
        ACTION_CHAT_ACCEPT: {
          title: 'Chat Accepted',
          value: 'Chat Accepted',
        },
        ACTION_CHAT_STARTED: {
          title: 'Chat Started',
          value: 'Chat Started',
        },
        ACTION_PARTNER_CHAT_STARTED: {
          title: 'Partner Chat Started',
          value: 'Partner Chat Started',
        },
        ACTION_BLOCK: {
          title: 'Block',
          value: 'Block',
        },
        ACTION_CREATE: {
          title: 'Create',
          value: 'Create',
        },
        ACTION_UPDATE: {
          title: 'Update',
          value: 'Update',
        },
        ACTION_LOGIN: {
          title: 'User Logged-in',
          value: 'Log In',
        },
        ACTION_LOGOUT: {
          title: 'User Logged-Out',
          value: 'Log Out',
        },
        ACTION_EDIT: {
          title: 'Edit',
          value: 'Edit',
        },
        ACTION_DELETE: {
          title: 'Delete',
          value: 'Delete',
        },
        ACTION_REPORT: {
          title: 'Report',
          value: 'Report',
        },
        ACTION_POST: {
          title: 'Posted',
          value: 'Post',
        },
        ACTION_REPLY: {
          title: 'Reply',
          value: 'Reply',
        },
        ACTION_TAG: {
          title: 'Tag',
          value: 'Tag',
        },
        ACTION_ENROLL: {
          title: 'Enroll',
          value: 'Enroll',
        },
        ACTION_UNENROLL: {
          title: 'Unenroll',
          value: 'Unenroll',
        },
        ACTION_WAITLIST_ADD: {
          title: 'Waitlist Add',
          value: 'Waitlist Add',
        },
        ACTION_WAITLIST_REMOVE: {
          title: 'Waitlist remove',
          value: 'Waitlist remove',
        },
        ACTION_UPLOAD: {
          title: 'Upload',
          value: 'Upload',
        },
        ACTION_MEETING_SCHEDULED: {
          title: 'Meeting Scheduled',
          value: 'Meeting Scheduled',
        },
        ACTION_OPEN: {
          title: 'Open',
          value: 'Open',
        },
        ACTION_CLOSE: {
          title: 'Close',
          value: 'Close',
        },
      },
      FIREHOSE_CATEGORIES: {
        CATEGORY_ANALYTICS: 'Analytics',
        CATEGORY_USER: 'User',
        CATEGORY_CONTINUING_EDUCATION: 'Continuing Education',
        CATEGORY_DOWNLOAD: 'Download',
        CATEGORY_MESSAGE: 'Message',
        CATEGORY_ADMIN: 'Admin',
        CATEGORY_SUPPORT_CHAT: 'Support Chat',
        CATEGORY_NOTIFICATION: 'Notification',
        CATEGORY_PAGE: 'Page',
        CATEGORY_QUESTION_FILL_IN_THE_BLANK: 'Question - Fill in the Blank',
        CATEGORY_QUESTION_MULTIPLE_CHOICE: 'Question - Multiple Choice',
        CATEGORY_QUESTION_ORDER: 'Question - Order',
        CATEGORY_QUESTION_POLL: 'Question - Poll',
        CATEGORY_QUESTION_RATING: 'Question - Rating',
        CATEGORY_QUESTION_SELECT_MANY: 'Question - Select Many',
        CATEGORY_QUESTION_RANKING: 'Question - Ranking',
        CATEGORY_COHORT: 'Cohort',
        CATEGORY_FORUM: 'Forum',
        CATEGORY_FEED: 'Feed',
        CATEGORY_COURSE: 'Course',
        CATEGORY_LESSON: 'Lesson',
        CATEGORY_META: 'Meta',
        CATEGORY_PARTNER: 'Partner',
        CATEGORY_ONE_TO_ONE_MEETING: '1-1 Meeting',
        CATEGORY_REVIEW: 'Review',
        CATEGORY_SLIDE: 'Slide',
        CATEGORY_BUCKET_BLURB: 'Content - Blurb',
        CATEGORY_BUCKET_MEDIA: 'Content - Media',
        CATEGORY_BUCKET_RESOURCES: 'Content - Resources',
        CATEGORY_BUCKET_SPEAKER: 'Content - Speaker',
        CATEGORY_BUCKET_PARTNER: 'Content - Partner',
        CATEGORY_BUCKET_LEADERBOARD: 'Content - Leaderboard',
        CATEGORY_BUCKET_ADS: 'Content - Ad',
        CATEGORY_BUCKET_LIBRARY: 'Content - Library',
        CATEGORY_BUCKET_LESSON: 'Content - Lesson',
        CATEGORY_BUCKET_TRACK: 'Content - Track',
        CATEGORY_BUCKET_OTSESSION: 'Content - OTSession',
        CATEGORY_BUCKET_GROUPOTSESSION: 'Content - GroupOTSession',
        CATEGORY_BUCKET_BREAKOUTOTSESSIO: 'Content - BreakoutOTSession',
        CATEGORY_BUCKET_IRLSESSION: 'Content - IRLSession',
        CATEGORY_BUCKET_COHORT: 'Content - Cohort',
        CATEGORY_BUCKET_PRODUCT: 'Content - Product',
        CATEGORY_BUCKET_COMMUNITY: 'Content - Community',
        CATEGORY_BUCKET_FORUMTOPIC: 'Content - ForumTopic',
        CATEGORY_BUCKET_FORUMPOST: 'Content - ForumPost',
      },
      FIREHOSE_OBJECTS: {
        OBJECT_QUESTION: 'Question',
        OBJECT_USER: 'User',
        OBJECT_CONTENT: 'Content',
        OBJECT_DOWNLOAD: 'Download',
        OBJECT_COMMENT: 'Comment',
        OBJECT_UPLOAD: 'Upload',
        OBJECT_CME: 'CME',
        OBJECT_COMMUNITY: 'Community',
      },
    };

    window.ANALYTICS_CONFIGURATION = ANALYTICS_CONFIGURATION;
  }
}
